import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { ScheduledItemCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { dateToString } from 'lib/helper'
import { SpecialHolidayType } from 'types/calendar'

type Props = {
  currentDate: Date
  currentMonth: Date
  row: Date[]
}

const ScheduledItemCalendarRow: FC<Props> = (props) => {
  const { currentDate, currentMonth, row } = props

  const closedDates = useSelector((state: State) => getClosedDates(state))
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = isSameDay(currentDate, date)
        const isClosed = closedDates.some((disabledDate) => isSameDay(disabledDate, date))
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))

        return (
          <ScheduledItemCalendarCell
            key={getDate(date)}
            isActive={isActive}
            isSpecialHoliday={isSpecialHoliday}
            currentMonth={currentMonth}
            date={date}
            isClosed={isClosed}
          />
        )
      })}
    </tr>
  )
}

export default ScheduledItemCalendarRow
